export default "__VITE_ASSET__b806af30__"